import { CustomerSettings, SELECTED_CUSTOMER_KEY } from './customer-settings';
import { autoinject } from 'aurelia-framework';
import { AlertService } from '@aurelia-toolkit/alert';
import { CustomerViewModel } from '@dynamik/common/clients/transaction-clients';
import { CustomersCache } from '../services/customers-cache';
import { CustomerService } from '@dynamik/common';
import { MyCustomerViewModel } from '@dynamik/common/clients/policy-clients';

@autoinject
export class CustomerSelector {
  constructor(private customerSettingsClass: CustomerSettings, private customerService: CustomerService, private customersCache: CustomersCache, private alertService: AlertService) { }

  customerIsSetPromiseResolve: (value?: (PromiseLike<boolean> | boolean)) => void;
  customerIsSetPromiseReject: (reason?: any) => void;
  customerIsSetPromise = new Promise((res, rej) => {
    this.customerIsSetPromiseResolve = res;
    this.customerIsSetPromiseReject = rej;
  });
  private customers: MyCustomerViewModel[];

  async setCustomerDefaultValue() {
    this.customers = await this.customersCache.get();
    if (!this.customers.length) {
      await this.alertService.error('You do not have access to any customers. Please contact your administrator.');
      this.customerSettingsClass.logout();
    }

    if (localStorage.getItem(SELECTED_CUSTOMER_KEY)) {
      try {
        const storedCustomer = MyCustomerViewModel.fromJS(JSON.parse(localStorage.getItem(SELECTED_CUSTOMER_KEY)));
        this.customerSettingsClass.selectedCustomer = this.customers.find(x => x.companyId === storedCustomer.companyId);
        this.customerService.selectCustomer(this.customerSettingsClass.selectedCustomer);
      } catch {
        // ignore
      }
    }
    if (!this.customerSettingsClass.selectedCustomer) {
      this.customerSettingsClass.selectedCustomer = this.customers[0];
    }

    this.customerIsSetPromiseResolve();
  }
}
